import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { sortTable } from 'src/app/helpers/sort-table';
import { EmergencyPatient } from 'src/app/_models/patient.model';
import { PatientService } from 'src/app/_services/patient.service';
import { baseUrl } from 'src/environments/environment';

@Component({
  selector: 'app-emergency-patients',
  templateUrl: './emergency-patients.component.html',
  styleUrls: ['./emergency-patients.component.scss'],
})
export class EmergencyPatientsComponent implements OnInit {
  pageTitle: string = 'Emergency Patients';
  placeholder: string = 'Search by patient name …';
  patientsArray: EmergencyPatient[] = [];
  filteredPatientsArray: EmergencyPatient[] = [];
  theadArray = [
    'Full Name',
    'Queue Number',
    'Status',
    'Date'
  ];
  invertSort: boolean = false;

  constructor(
    private patientService: PatientService,
    public toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.getAllEmergencyPatients();
  }

  getAllEmergencyPatients() {
    this.patientService.getAllEmergencyPatients().subscribe((res) => {
      res?.data?.patientsEmergency.map((patient) => {
        patient.imagePath = `${patient.imagePath}`;
        this.patientsArray.push(patient);
      });

      this.filteredPatientsArray = [...this.patientsArray];
    });
  }

  invertSorting() {
    this.invertSort = !this.invertSort;

    this.filteredPatientsArray = sortTable(
      this.filteredPatientsArray,
      'fullName',
      this.invertSort
    );
  }

  onSearchPatients(searchString) {
    if (!searchString) {
      this.filteredPatientsArray = [...this.patientsArray];
    }
    else{
      this.patientService
      .searchByName(searchString)
      .subscribe((response) => {
        this.filteredPatientsArray = response['data']['patientsEmergency'];
      });
    }
    
  }

  onSearchInputKeyup(searchString) {
    if (!searchString) {
      this.filteredPatientsArray = [...this.patientsArray];
    }
  }
}
